module.exports = __webpack_public_path__ + "static/media/report.bf9acb7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/modal-images/report.png
// module id = 575
// module chunks = 0